import React from 'react'
import PropTypes from 'prop-types'

import AddButton from './AddButton'
import UnitList from './UnitList'
import UnitFormDialog from './UnitFormDialog'

class UnitAdmin extends React.Component {
  static propTypes = {
    units: PropTypes.object.isRequired,
    onCreateUnit: PropTypes.func.isRequired,
    onUpdateUnit: PropTypes.func.isRequired,
  }

  state = {
    isAddingUnit: false,
    isEditingUnit: false,
    unitToEdit: null,
  }

  onAddDialogOpen = () => {
    this.setState({ isAddingUnit: true })
  }

  onAddDialogClose = () => {
    this.setState({ isAddingUnit: false })
  }

  onEditDialogOpen = (unit) => {
    this.setState({
      unitToEdit: unit,
      isEditingUnit: true,
    })
  }

  onEditDialogClose = () => {
    this.setState({
      unitToEdit: null,
      isEditingUnit: false,
    })
  }

  render() {
    const { units, onCreateUnit, onUpdateUnit } = this.props
    const { isAddingUnit, isEditingUnit, unitToEdit } = this.state

    return (
      <div>
        <AddButton label="Add Unit" onClick={this.onAddDialogOpen} />

        <UnitList units={units} onEdit={this.onEditDialogOpen} />

        {isEditingUnit && (
          <UnitFormDialog
            title={`Edit Unit ${(unitToEdit && unitToEdit.id) || ''}`}
            onSubmit={onUpdateUnit}
            onClose={this.onEditDialogClose}
            unit={unitToEdit}
          />
        )}

        {isAddingUnit && (
          <UnitFormDialog
            title="Add Unit"
            onSubmit={onCreateUnit}
            onClose={this.onAddDialogClose}
          />
        )}
      </div>
    )
  }
}

export default UnitAdmin
